const drawDandelion = (ctx, cx, cy, r) => {
  ctx.save();
  ctx.strokeStyle = "#B45309";
  ctx.lineWidth = 6;
  ctx.beginPath();
  ctx.moveTo(cx, cy + r + 250);
  ctx.quadraticCurveTo(cx - 20, cy + r + 100, cx, cy);
  ctx.stroke();
  const glow = ctx.createRadialGradient(cx, cy, 10, cx, cy, r * 1.4);
  glow.addColorStop(0, "rgba(252, 211, 77, 0.55)");
  glow.addColorStop(1, "rgba(252, 211, 77, 0)");
  ctx.fillStyle = glow;
  ctx.beginPath();
  ctx.arc(cx, cy, r * 1.4, 0, Math.PI * 2);
  ctx.fill();
  ctx.strokeStyle = "#FBBF24";
  ctx.lineWidth = 3;
  for (let i = 0; i < 28; i++) {
    const a = (i / 28) * Math.PI * 2;
    const x2 = cx + Math.cos(a) * r;
    const y2 = cy + Math.sin(a) * r;
    ctx.beginPath();
    ctx.moveTo(cx, cy);
    ctx.lineTo(x2, y2);
    ctx.stroke();
    ctx.fillStyle = "#FCD34D";
    ctx.beginPath();
    ctx.arc(x2, y2, 6, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.fillStyle = "#D97706";
  ctx.beginPath();
  ctx.arc(cx, cy, 22, 0, Math.PI * 2);
  ctx.fill();
  // drifting seeds
  ctx.fillStyle = "#FCD34D";
  [[1.6, -0.9], [2.1, -0.5], [2.5, -1.2], [1.9, -1.6]].forEach(([dx, dy]) => {
    ctx.globalAlpha = 0.8;
    ctx.beginPath();
    ctx.arc(cx + dx * r, cy + dy * r, 7, 0, Math.PI * 2);
    ctx.fill();
  });
  ctx.restore();
};

export const generateRecapImage = (recap) =>
  new Promise((resolve) => {
    const W = 1080;
    const H = 1350;
    const c = document.createElement("canvas");
    c.width = W;
    c.height = H;
    const ctx = c.getContext("2d");

    ctx.fillStyle = "#0F766E";
    ctx.fillRect(0, 0, W, H);
    ctx.fillStyle = "rgba(255,255,255,0.04)";
    ctx.beginPath();
    ctx.arc(W, 0, 500, 0, Math.PI * 2);
    ctx.fill();

    ctx.textAlign = "center";
    ctx.fillStyle = "#FCD34D";
    ctx.font = "bold 34px Georgia, serif";
    ctx.fillText("M Y   W E E K   I N   B L O O M", W / 2, 140);
    ctx.fillStyle = "rgba(255,255,255,0.75)";
    ctx.font = "italic 30px Georgia, serif";
    ctx.fillText("A little growth, every day", W / 2, 195);

    drawDandelion(ctx, W / 2, 430, 130);

    const stats = [
      [String(recap.perfect_days), recap.perfect_days === 1 ? "PERFECT DAY" : "PERFECT DAYS"],
      [String(recap.streak), "DAY STREAK"],
      [`+${recap.points_this_week}`, "GARDEN POINTS"],
    ];
    stats.forEach(([value, label], i) => {
      const x = ((2 * i + 1) * W) / 6;
      ctx.fillStyle = "rgba(255,255,255,0.08)";
      const bx = x - 140;
      ctx.beginPath();
      ctx.roundRect(bx, 880, 280, 240, 28);
      ctx.fill();
      ctx.fillStyle = "#FCD34D";
      ctx.font = "bold 92px Georgia, serif";
      ctx.fillText(value, x, 1000);
      ctx.fillStyle = "rgba(255,255,255,0.85)";
      ctx.font = "bold 24px Arial, sans-serif";
      ctx.fillText(label, x, 1065);
    });

    ctx.strokeStyle = "rgba(252, 211, 77, 0.5)";
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(W / 2 - 120, 1190);
    ctx.lineTo(W / 2 + 120, 1190);
    ctx.stroke();
    ctx.fillStyle = "#FCD34D";
    ctx.font = "bold 26px Arial, sans-serif";
    ctx.fillText("D A N D E L I O N   F A R M  ·  H O U S E   O F   B L O O M", W / 2, 1245);
    ctx.fillStyle = "rgba(255,255,255,0.7)";
    ctx.font = "italic 26px Georgia, serif";
    ctx.fillText("Plant yourself. Bloom anyway.", W / 2, 1295);

    c.toBlob(resolve, "image/png");
  });
